import { storeToRefs } from 'pinia';
import type { IDashboard } from '@/modules/dashboard/interfaces/dashboard';
import { useDashboardStore } from '@/modules/dashboard/stores/dashboard';

const useDashboard = () => {
    const storeDasboard = useDashboardStore();
    const { dashboard } = storeToRefs(storeDasboard);

    const getDashboard = async (): Promise<IDashboard[]> => {
        const data = [
            {
                name: 'Email Meter',
                created: '2023-06-02',
                dashboard_url: 'https://lookerstudio.google.com/embed/reporting/79b1e8e7-6881-4cb9-8ba4-49bbf29460d7/',
                dashboard_embedded_url: 'https://lookerstudio.google.com/embed/reporting/79b1e8e7-6881-4cb9-8ba4-49bbf29460d7/'
            }
        ];
        if (data) storeDasboard.setDashboard(data);
        return data;
    };

    const href = (e: { preventDefault: () => void }) => {
        if (dashboard.value.length) window.open(dashboard.value[0].dashboard_url, '_blank');
        else e.preventDefault();
    };

    return {
        // properties
        dashboard,

        // Method
        href,
        getDashboard
    };
};

export default useDashboard;
